<template>
  <div>
    <h4 class="h5 fw-bolder">Filtros avançados</h4>
    <div class="row no-gutters">
      <date-input
        v-model="modelValue.start"
        size="sm"
        class="mr-2"
        placeholder="Data inicial"
      />
      <date-input v-model="modelValue.end" size="sm" placeholder="Data final" />
    </div>
    <p class="small text-muted mt-4">
      Após selecionar os filtros, clique em
      <b-badge variant="bagsis" pill class="ml-1">Buscar</b-badge>
    </p>
  </div>
</template>
<script>
import DateInput from "@/components/Form/DateInput.vue";

export default {
  emits: ["input"],
  components: { DateInput },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: Object,
      default: () => ({ start: "", end: "" }),
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
<style scoped lang="scss"></style>
